module.exports = __webpack_public_path__ + "static/media/attachment-3.1a8068aa.jpg";